var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5018 11.4236C14.791 11.4236 16.6442 9.53941 16.6442 7.21182C16.6442 4.88424 14.791 3 12.5018 3C10.2125 3 8.35934 4.88424 8.35934 7.21182C8.35934 9.53941 10.2125 11.4236 12.5018 11.4236ZM12.5018 4.33005C14.0716 4.33005 15.3361 5.61576 15.3361 7.21182C15.3361 8.80788 14.0716 10.0936 12.5018 10.0936C10.932 10.0936 9.66748 8.80788 9.66748 7.21182C9.66748 5.61576 10.932 4.33005 12.5018 4.33005Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65404 21.0027H19.3459C19.7165 21.0027 20 20.7146 20 20.3377V17.8993C20 14.5963 17.3619 11.9141 14.1133 11.9141H10.8866C7.63805 11.9141 4.99997 14.5963 4.99997 17.8993V20.3377C4.99997 20.7146 5.2834 21.0027 5.65404 21.0027ZM6.30811 17.9215C6.30811 15.35 8.35753 13.2663 10.8866 13.2663H14.1133C16.6424 13.2663 18.6918 15.35 18.6918 17.9215V19.6949H6.30811V17.9215Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEmail);
export default __webpack_public_path__ + "static/media/userEmail.5c880758fbc726823142dcd96987408b.svg";
export { ForwardRef as ReactComponent };